import { cn } from "@/lib/utils";

interface OptionCardProps {
  label: string;
  value: number;
  selected: boolean;
  onSelect: (value: number) => void;
}

export const OptionCard = ({ label, value, selected, onSelect }: OptionCardProps) => {
  return (
    <button
      type="button"
      onClick={() => onSelect(value)}
      className={cn(
        "w-full flex items-center lg:items-start gap-2 rounded-[4px] border border-[#00000017] bg-bg-surface px-4 py-3 text-left transition-colors",
        selected
          ? "border-border-primary bg-bg-fill-primary-subtle"
          : "border-border-neutral-light hover:border-border-neutral-medium",
      )}
    >
      {/* Radio circle */}
      <div
        className={cn(
          "mt-[2px] size-5 shrink-0 rounded-full border",
          selected ? "border-[6px] border-[#000000] bg-white" : "border-[#00000030] bg-white",
        )}
      />

      {/* Label text */}
      <span className={cn("flex-1 text-body leading-6 text-[#000000]", selected && "font-medium")}>
        {`${value}: ${label}`}
      </span>
    </button>
  );
};
